import React from 'react';

import { IHostProps } from '@wix/yoshi-flow-editor';

import { useMobileActionBarButton } from '@/hooks';

export interface MobileActionBarButtonProps {
  host: IHostProps;
}

// Keep `host` prop outside the hook consumer so the component stays cacheable.
export const MobileActionBarButton: React.FC<MobileActionBarButtonProps> = ({
  host,
}) => {
  useMobileActionBarButton(host);

  return null;
};
